import {InputHTMLAttributes, ReactNode} from "react";
import classNames from "classnames";
import styles from "./Radio.module.scss";

type Props = Omit<
    InputHTMLAttributes<HTMLInputElement>,
    "type"
> & {
    label?: ReactNode;
    bordered?: boolean;
    textPosition?: "left" | "right";
    inputClassName?: string;
    fullWidth?: boolean;
    errorMessage?: string;
};

export const Radio = (
    {
        label,
        disabled = false,
        bordered = false,
        textPosition = "right",
        className,
        inputClassName,
        fullWidth,
        errorMessage,
        ...otherProps
    }: Props
) => {
    const containerClassName = classNames(
        styles.container,
        styles[textPosition],
        className,
        {
            [styles.disabled]: disabled,
            [styles.bordered]: bordered,
            [styles.fullWidth]: fullWidth,
        }
    );

    return (
        <label className={containerClassName}>
            <span className={styles.radio}>
                <input
                    type={`radio`}
                    disabled={disabled}
                    className={classNames(styles.input, inputClassName)}
                    {...otherProps}
                />
                <span className={styles.parentCircle}>
                    <span className={styles.childCircle} />
                </span>
            </span>
            {label !== undefined && label !== null && (<span className={styles.label}>{label}</span>)}
        </label>
    );
};
